import ShopifyObject from './ShopifyObject';
import VariantFeaturedImage from './VariantFeaturedImage';

export default class Variant extends ShopifyObject {
  /**
   * @param {ShopifyVariant} variant
   */
  constructor(variant) {
    super(variant.id);

    this._title = variant.title || '';
    this._sku = variant.sku || '';
    this._requiresShipping = variant.requires_shipping || false;
    this._taxable = variant.taxable || false;
    this._available = variant.available || false;
    this._name = variant.name || '';
    this._publicTitle = variant.public_title || null;
    this._options = variant.options || [];
    this._price = variant.price || 0;
    this._weight = variant.weight || 0;
    this._compareAtPrice = variant.compare_at_price || null;
    this._inventoryQuantity = variant.inventory_quantity || 0;
    this._inventoryManagement = variant.inventory_management || null;
    this._inventoryPolicy = variant.inventory_policy || '';
    this._barcode = variant.barcode || '';
    this._featuredImage = variant.featured_image
      ? new VariantFeaturedImage(variant.featured_image)
      : null;
  }

  /**
   * @returns {string}
   */
  get title() {
    return this._title;
  }

  /**
   * @returns {string}
   */
  get option1() {
    return this._options[0] || null;
  }

  /**
   * @returns {string}
   */
  get option2() {
    return this._options[1] || null;
  }

  /**
   * @returns {string}
   */
  get option3() {
    return this._options[2] || null;
  }

  /**
   * @returns {string}
   */
  get sku() {
    return this._sku;
  }

  /**
   * @returns {boolean}
   */
  get requiresShipping() {
    return this._requiresShipping;
  }

  /**
   * @returns {boolean}
   */
  get taxable() {
    return this._taxable;
  }

  /**
   * @returns {VariantFeaturedImage}
   */
  get featuredImage() {
    return this._featuredImage;
  }

  /**
   * @returns {boolean}
   */
  get available() {
    return this._available;
  }

  /**
   * @returns {string}
   */
  get name() {
    return this._name;
  }

  /**
   * @returns {string}
   */
  get publicTitle() {
    return this._publicTitle;
  }

  /**
   * @returns {string[]}
   */
  get options() {
    return this._options;
  }

  /**
   * @returns {number}
   */
  get price() {
    return this._price;
  }

  /**
   * @returns {number}
   */
  get weight() {
    return this._weight;
  }

  /**
   * @returns {number}
   */
  get compareAtPrice() {
    return this._compareAtPrice;
  }

  /**
   * @returns {number}
   */
  get inventoryQuantity() {
    return this._inventoryQuantity;
  }

  /**
   * @returns {string}
   */
  get inventoryManagement() {
    return this._inventoryManagement;
  }

  /**
   * @returns {string}
   */
  get inventoryPolicy() {
    return this._inventoryPolicy;
  }

  /**
   * @returns {string}
   */
  get barcode() {
    return this._barcode;
  }

  /**
   * @returns {boolean}
   */
  get hasStock() {
    return this._inventoryQuantity > 0;
  }

  /**
   *
   * @return {Object} - Shopify Variant Object.
   */
  JSON() {
    return {
      available: this.available,
      barcode: this.barcode,
      compare_at_price: this.compareAtPrice,
      featured_image: this.featuredImage
        ? this.featuredImage.JSON()
        : this.featuredImage,
      id: super.id,
      inventory_management: this.inventoryManagement,
      inventory_policy: this.inventoryPolicy,
      inventory_quantity: this.inventoryQuantity,
      name: this.name,
      option1: this.option1,
      option2: this.option2,
      option3: this.option3,
      options: this.options,
      price: this.price,
      public_title: this.publicTitle,
      requires_shipping: this.requiresShipping,
      sku: this.sku,
      taxable: this.taxable,
      title: this.title,
      weight: this.weight,
    };
  }
}
